module.exports = __webpack_public_path__ + "static/media/result-error.a5988324.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/result-error.svg
// module id = 1581
// module chunks = 0